<template>
  <div class="mt-n1 py-2 font-size-sm bg-white rounded-md shadow-custom">
    <div class="d-flex justify-content-around align-items-center">
      <template v-for="(item, index) in keyIndicators">
        <div class="w-100 text-center" style="cursor: pointer" :key="index" @click="redirect(item.name)">
          <h4 class="font-weight-normal text-customize">{{ item.value }}</h4>
          <div class="w-100" :class="[(index !== keyIndicators.length -1) ? 'border-right border-light' : '']">{{ item.wording }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  data() {
    return {
      // 關鍵指標
      keyIndicators: [],
    };
  },
  created() {
    this.getMemberIndicator();
  },
  methods: {
    // 導向指定頁面
    redirect(name) {
      const vm = this;
      vm.$router.push({ path: `/${name}`, query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
    // 取得會員關鍵指標
    getMemberIndicator() {
      const vm = this;

      const pageSetting = vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage');
      const incicator = vm.$store.dispatch('getMemberIndicator');
      Promise.all([pageSetting, incicator]).then(([setting, indicators]) => {
        vm.keyIndicators = indicators
          .map((x) => ({ ...x, func: pageSettingGetter.getFunction(setting, x.name) || null }))
        // 篩選出要顯示的關鍵指標
          .filter((x) => !!x.func)
        // 排序
          .sort((a, b) => a.func.order - b.func.order)
        // 顯示文案
          .map((x) => ({ ...x, wording: pageSettingGetter.getFunctionWording(setting, x.name) }));
      });
    },
  },
  watch: {
    $route() {
      // 切換route時，更新關鍵指標
      this.getMemberIndicator();
    },

  },
};
</script>
